module.exports = __webpack_public_path__ + "img/dome1.6e2ed316.jpg";